import { Component } from '@theme/component';
let stampedReady;
function loadStamped() {
  if (window.StampedFn) return Promise.resolve(window.StampedFn);
  if (!stampedReady) stampedReady = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://cdn1.stamped.io/files/widget.min.js';
    script.async = true;
    script.onload = () => resolve(window.StampedFn);
    script.onerror = () => { stampedReady = undefined; reject(new Error('Stamped unavailable')); };
    document.head.append(script);
  });
  return stampedReady;
}
class GreenStampedReviews extends Component {
  #observer;
  #controller;
  #contentObserver;
  #cleanReviewText = () => {
    this.querySelectorAll('.stamped-review-content-body').forEach((body) => {
      const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.data.includes('\uFFFD')) node.data = node.data.replace(/\uFFFD/g, '');
      }
    });
  };
  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#observer?.disconnect();
    this.#contentObserver?.disconnect();
    this.#contentObserver = new MutationObserver(this.#cleanReviewText);
    this.#contentObserver.observe(this, { childList: true, subtree: true, characterData: true });
    this.#cleanReviewText();
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.#observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      this.#observer.disconnect();
      loadStamped().then((stamped) => {
        if (signal.aborted || !this.isConnected) return;
        stamped.init({ apiKey: this.dataset.apiKey, storeUrl: this.dataset.storeId });
      }).catch(() => { /* The link to existing reviews remains available if Stamped is unavailable. */ });
    }, { rootMargin: '500px' });
    this.#observer.observe(this.closest('.green-stamped') || this);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
    this.#controller?.abort();
    this.#contentObserver?.disconnect();
  }
}
if (!customElements.get('green-stamped-reviews')) customElements.define('green-stamped-reviews', GreenStampedReviews);
